import { withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "children"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TreeParameterNode = _resolveComponent("TreeParameterNode", true)!

  return (_ctx.IsVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["node", {gridRow: _ctx.GridRows}])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["node-main", {selected: _ctx.IsSelected}]),
          style: _normalizeStyle(_ctx.RowIndentStyle),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.Value_Click()), ["stop"]))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["expander", {expanded: _ctx.IsExpanded, collapsed: !_ctx.IsExpanded, hidden: !_ctx.HasChildren}]),
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.Expander_Click && _ctx.Expander_Click(...args)), ["stop"]))
          }, null, 2),
          (_ctx.GridRows)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["theme-svg", _ctx.HasChildren ? 'nonleafnode' : 'leafnode'])
              }, null, 2))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass(["label", {disabled: _ctx.DisplayOnly, highlightBlue: _ctx.GridRows && _ctx.IsSearchMatch, highlightYellow: _ctx.GridRows && _ctx.IsCurrentMatch}])
          }, _toDisplayString(_ctx.ShownLabel), 3)
        ], 6),
        (_ctx.ShowChildren)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Children, (child, i) => {
                return (_openBlock(), _createBlock(_component_TreeParameterNode, {
                  key: child.Value.key || i,
                  Definition: child,
                  SearchText: _ctx.SearchText,
                  AutoExpand: _ctx.AutoExpand,
                  ShowOnlyMatches: _ctx.ShowOnlyMatches,
                  MatchNameAndCaption: _ctx.MatchNameAndCaption,
                  DisplayMode: _ctx.DisplayMode,
                  HighlightedKey: _ctx.HighlightedKey,
                  GridRows: _ctx.GridRows
                }, null, 8, ["Definition", "SearchText", "AutoExpand", "ShowOnlyMatches", "MatchNameAndCaption", "DisplayMode", "HighlightedKey", "GridRows"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}